var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMirror(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40ZM11.5514 29.7837H28.4485V15.8759C28.4485 13.3013 25.3372 8.27832 20.3035 8.27832C13.4232 8.27832 11.5514 14.5886 11.5514 15.8759V29.7837Z",
    fill: "#A8A1B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirror);
export default __webpack_public_path__ + "static/media/mirror.fe71d7aeeaca2bb8aa57e63bdfee6b04.svg";
export { ForwardRef as ReactComponent };